import { palette } from '@/modules/defines/styles';
import styled from 'styled-components';
import { memo, useState } from 'react';
import Elevator from '@/assets/icon/minimap/Elevator';
import Escalator from '@/assets/icon/minimap/Escalator';
import Stair from '@/assets/icon/minimap/Stair';
import TablerX from '@/assets/icon/minimap/TablerX';
import Route from '@/assets/icon/minimap/Route';
import { logClickNaviButton } from '@/utils/amplitude';
type PathType = 'Stair' | 'Escalator' | 'Elevator' | 'Short';

interface FloatingButtonProps {
  selectedPath: PathType;
  onStairClick: () => void;
  onEscalatorClick: () => void;
  onElevatorClick: () => void;
  onRouteClick: () => void;
}
const FloatingButton = ({
  selectedPath,
  onElevatorClick,
  onEscalatorClick,
  onStairClick,
  onRouteClick,
}: FloatingButtonProps) => {
  const [toggle, setToggle] = useState(false);

  const handleIconClick = () => {
    setToggle(false);
  };

  const renderIcon = (icon: PathType | null) => {
    switch (icon) {
      case 'Stair':
        return <Stair width="24" height="24" fill={palette.secondaryRed700} />;
      case 'Escalator':
        return (
          <Escalator width="24" height="24" fill={palette.secondaryRed700} />
        );
      case 'Elevator':
        return (
          <Elevator width="24" height="24" fill={palette.secondaryRed700} />
        );
      case 'Short':
        return <Route width="24" height="24" fill={palette.secondaryRed700} />;
      default:
        return null;
    }
  };

  return (
    <Wrapper>
      <Absolute>
        <ButtonGroup $expanded={toggle}>
          {toggle && (
            <>
              <Button
                type="button"
                onClick={() => {
                  handleIconClick();
                  logClickNaviButton('Stair');
                  onStairClick();
                }}
              >
                <Stair width="24" height="24" fill={palette.secondaryRed700} />
              </Button>
              <Button
                type="button"
                onClick={() => {
                  handleIconClick();
                  logClickNaviButton('Escalator');
                  onEscalatorClick();
                }}
              >
                <Escalator
                  width="24"
                  height="24"
                  fill={palette.secondaryRed700}
                />
              </Button>
              <Button
                type="button"
                onClick={() => {
                  handleIconClick();
                  logClickNaviButton('Elevator');
                  onElevatorClick();
                }}
              >
                <Elevator
                  width="24"
                  height="24"
                  fill={palette.secondaryRed700}
                />
              </Button>

              <Button
                $borderColor={palette.gray500}
                type="button"
                onClick={() => {
                  handleIconClick();
                  logClickNaviButton('Short');
                  onRouteClick();
                }}
              >
                <Route width="24" height="24" fill={palette.secondaryRed700} />
              </Button>
              <Button
                $borderColor={palette.gray500}
                type="button"
                onClick={() => setToggle(!toggle)}
              >
                <TablerX width="24" height="24" fill={palette.gray500} />
              </Button>
            </>
          )}
        </ButtonGroup>
        {!toggle && (
          <Button type="button" onClick={() => setToggle(true)}>
            {renderIcon(selectedPath)}
          </Button>
        )}
      </Absolute>
    </Wrapper>
  );
};
const Absolute = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 1.25rem;
  z-index: 22;
`;
const ButtonGroup = styled.div<{ $expanded: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
  max-height: ${({ $expanded }) => ($expanded ? '400px' : '50px')};
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0)};
`;

const Wrapper = styled.div`
  width: 496px;
  height: auto;
  max-width: 90%;
  position: relative;
`;

const Button = styled.button<{
  $borderColor?: string;
}>`
  width: 3.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3.125rem;
  padding: 0.625rem;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
  border-radius: 62.5rem;
  border: 1px solid
    ${($props) => $props.$borderColor || palette.secondaryRed700};
  background: ${palette.opacityWhite80};
  &:active {
    transform: scale(0.95);
  }
`;
export default memo(FloatingButton);
